export * from './variant-c'
